
import { FastingStateInput, FastingPersistentState } from './types';
import { saveToLocalStorage, clearLocalStorage } from './storage';
import { saveToCookies, clearCookies } from './cookies';
import { trackFastingProgress, trackFastEnd } from './analytics';

/**
 * Saves fasting state to localStorage and cookies
 */
export const saveFastingState = (state: FastingStateInput): void => {
  try {    // Convert fasting state for storage
    const stateToSave: FastingPersistentState = {
      isActive: state.isActive,
      isPaused: state.isPaused,
      timeElapsed: state.timeElapsed,
      selectedProtocolId: state.selectedProtocol.id,
      selectedProtocol: state.selectedProtocol,
      waterIntake: state.waterIntake,
      startTime: state.startTime,
      pausedTime: state.pausedTime,
      endTime: state.endTime,
      totalPauseDuration: state.totalPauseDuration,
      lastSaved: Date.now()
    };
    
    // Save to localStorage (primary storage)
    saveToLocalStorage(stateToSave);
    
    // Save to cookies if consent is given
    saveToCookies(state);
    
    // Track analytics
    trackFastingProgress(state);
  } catch (error) {
    console.error("Error saving fasting state:", error);
  }
};

/**
 * Clears all fasting state from localStorage and cookies
 */
export const clearFastingState = (): void => {
  // Clear cookies if consent was given
  clearCookies();
  
  // Clear localStorage
  clearLocalStorage();
  
  // Track analytics
  trackFastEnd();
};
